<template>
  <q-select outlined :modelValue="modelValue" :label="label" @update:modelValue="$emit('update:modelValue', $event)"
    use-input hide-selected fill-input input-debounce="1000" :options="options" @filter="filterFn"
    @filter-abort="abortFilterFn" :error="error">
    <template v-slot:option="scope">
      <q-item v-bind="scope.itemProps">
        <q-item-section>
          <q-item-label>{{ scope.opt.label }}</q-item-label>
          <q-item-label caption>{{ scope.opt.value }}</q-item-label>
        </q-item-section>
        <q-item-section avatar>
          <q-item-label>U$S {{ round(scope.opt.precio, 2) }}</q-item-label>
        </q-item-section>
      </q-item>
    </template>
    <template v-slot:no-option>
      <q-item>
        <q-item-section class="text-grey">
          No results
        </q-item-section>
      </q-item>
    </template>
    <template v-slot:error>
      <span v-for="err in errors" :key="err">{{ err }}</span>
    </template>
  </q-select>
</template>

<script setup>
import PrecioListaService from '@/services/PrecioListaService';
import { computed, ref } from 'vue'
import { round } from 'mathjs'

const props = defineProps({
  modelValue: [String, Number],
  errors: [String, Array],
  label: [String]
});
defineEmits(['update:modelValue']);
const options = ref([]);
const error = computed(() => props?.errors && props?.errors?.length !== 0)
const abortFilterFn = () => console.log('delayed filter aborted')

const filterFn = async (val, update, abort) => {
  if (!val) {
    abort()
    return []
  };
  const results = await PrecioListaService.getPuertaList(val)
  update(() => options.value = results)
}
</script>
